import { render, staticRenderFns } from "./RelatedSelect.vue?vue&type=template&id=52d70ce8&"
import script from "./RelatedSelect.vue?vue&type=script&lang=ts&"
export * from "./RelatedSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports